import { connect, bindActionCreators } from '../dependencies';

import { leftPanelOpenSelector } from '../services/selectors';
import { toggleLeftPanel } from '../services/actions';
import LeftPanel from '../components/LeftPanel';

const mapStateToProps = state => ({
    open: leftPanelOpenSelector(state),
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            onClose: () => toggleLeftPanel(false),
        },
        dispatch,
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(LeftPanel);
